import { Tab, Tabs } from 'react-bootstrap';
import ToleranceGraphs from './ToleranceGrade';
import PreFlatness from './PreFlatness';
import PostFlatness from './PostFlatness';
import ShipmentGraphs from './shipment';


export const MetricContainer = () => {
  return <Tabs defaultActiveKey="metric-2d-tolerance">
    <Tab eventKey="metric-2d-tolerance" title="2D tolerance">
      <ToleranceGraphs />
    </Tab>
    <Tab eventKey="metric-prelam-flatness" title="Prelam. Flatness">
      <PreFlatness />
    </Tab>
    <Tab eventKey="metric-postlam-flatness" title="Postlam. Flatness">
      <PostFlatness />
    </Tab>
    <Tab eventKey="metric-shipment" title="Shipment">
      <ShipmentGraphs />
    </Tab>
  </Tabs>
}

export default MetricContainer;

